import Vue from 'vue'
import 'chartist/dist/chartist.min.css'

Vue.use(require('vue-chartist'))



// WEBPACK FOOTER //
// ./VueSrc/Common/Components/materialcomponents/plugins/chartist.js